import { Box, Button, Checkbox, Divider, Form, Grid, Text } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { FC, Fragment, memo } from 'react';
import { useForm } from 'react-hook-form';

import { messages } from './AcceptInvitations.messages';
import { AcceptInvitationsProps } from './AcceptInvitations.types';

export const AcceptInvitations: FC<AcceptInvitationsProps> = memo((props) => {
    const { defaultAcceptedInvitationIds, invitations, loading, onSubmit } = props;

    const form = useForm({
        defaultValues: {
            invites: defaultAcceptedInvitationIds,
        },
    });

    const handleNext = form.handleSubmit((data) => {
        return onSubmit(data.invites);
    });

    return (
        <Form form={form} onSubmit={handleNext}>
            <Text font='headline' fontSize='medium' fontWeight='medium' spacing='0 0 32' color='midnight80'>
                {messages.title}
            </Text>

            <Text font='body' fontSize='large' spacing='0 0 24' color='midnight80'>
                {messages.description}
            </Text>

            <Checkbox.Group name='invites' direction='column' size='medium' invalid={false} spacing='8'>
                {invitations.map((invitation) => (
                    <Fragment key={invitation.companyId}>
                        <label>
                            <Grid gridTemplateColumns='1fr auto' alignItems='center'>
                                <Grid gap={4}>
                                    <Text font='body' fontSize='large' fontWeight='medium' color='midnight100'>
                                        {invitation.companyName}
                                    </Text>

                                    <Text font='label' fontSize='medium' color='midnight70'>
                                        {messages.invitedBy({
                                            name: selectors.user.getDisplayName(
                                                invitation.inviterUserFirstName,
                                                invitation.inviterUserLastName,
                                                invitation.inviterUserEmail
                                            ),
                                        })}
                                    </Text>
                                </Grid>

                                <Checkbox key={invitation.companyId} value={invitation.companyId}>
                                    {messages.accept}
                                </Checkbox>
                            </Grid>
                        </label>

                        <Divider />
                    </Fragment>
                ))}
            </Checkbox.Group>

            <Grid justifyContent='end'>
                <Box minWidth={166} spacing='32 0 0'>
                    <Button block progress={loading} type='submit' color='mint80' size='large'>
                        {messages.next}
                    </Button>
                </Box>
            </Grid>
        </Form>
    );
});

AcceptInvitations.displayName = 'AcceptInvitations';
